import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Result, Spin, Descriptions } from 'antd';
import { SafetyCertificateOutlined, CloseCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import axios from 'axios';

const CertificateVerify = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [certificate, setCertificate] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    const verify = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL || 'http://aliaga-robotik-backend.test/api'}/certificates/${token}/verify`
        );
        setCertificate(res.data);
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    verify();
  }, [token]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card style={{ maxWidth: 500, width: '100%' }}>
        {error ? (
          <Result
            icon={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
            status="error"
            title="Sertifika Geçersiz"
            subTitle="Bu QR koda ait geçerli bir sertifika bulunamadı."
          />
        ) : (
          <Result
            icon={<SafetyCertificateOutlined style={{ color: '#52c41a' }} />}
            status="success"
            title="Sertifika Geçerli"
            subTitle="Bu sertifika, Özel Aliağa Robotik Kodlama Kişisel Gelişim Kursu tarafından düzenlenmiş ve doğrulanmıştır."
            extra={
              <Descriptions column={1} bordered size="small">
                <Descriptions.Item label="Öğrenci">{certificate.student_name}</Descriptions.Item>
                <Descriptions.Item label="Belge Türü">Başarı Sertifikası</Descriptions.Item>
                <Descriptions.Item label="Sertifika Programı">{certificate.course_name}</Descriptions.Item>
                <Descriptions.Item label="Sertifika No">{certificate.certificate_number}</Descriptions.Item>
                <Descriptions.Item label="Düzenlenme Tarihi">
                  {dayjs(certificate.issued_at).format('DD.MM.YYYY')}
                </Descriptions.Item>
              </Descriptions>
            }
          />
        )}
      </Card>
    </div>
  );
};

export default CertificateVerify;
